import React from 'react';
import { useNavigate } from 'react-router-dom';

export function Pricing() {
  const navigate = useNavigate();
  return (
    <div className="pricing-center">
      <div className="pricing-badge">
        <svg width="12" height="12" viewBox="0 0 12 12" fill="none" stroke="currentColor" strokeWidth={1.5}>
          <circle cx="6" cy="6" r="5" /><line x1="6" y1="4" x2="6" y2="6.5" /><circle cx="6" cy="8.5" r=".5" fill="currentColor" />
        </svg>
        Simple Pricing
      </div>
      <h1 className="s-h2">Simple pricing for every music professional.</h1>
      <div className="pricing-free">Free</div>
      <div className="s-body" style={{ textAlign: 'center', marginBottom: 12 }}>to get started</div>
      <p className="s-body" style={{ textAlign: 'center', marginBottom: 36 }}>Create your profile, build your portfolio, discover talent, and explore opportunities at no cost. Pro tools for artists and organizations are coming soon — create your profile now to get early access.</p>
      <div className="cta-actions">
        <button className="btn btn-primary btn-lg" onClick={() => navigate('/for-artists')}>Create your profile</button>
        <button className="btn btn-ghost btn-lg">Explore Tarana</button>
      </div>
      <p className="pricing-sub" style={{ marginTop: 24 }}>Pro plan coming soon · Join now for early access</p>
    </div>
  );
}
